import CongratulationsSection from './CongratulationsSection'

export default CongratulationsSection
